import styled from "styled-components"

export const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const VideoPlayerWrapper = styled(Row)`
  position: relative;
  flex-direction: column;

  .mm--replace-video {
    margin-right: 1rem;

    i.Pathicon {
      color: #fff !important;
    }

    &:hover {
      opacity: 0.8;
    }
  }

  .mm--cover-image.Button.secondary,
  .mm--cover-image .Button.secondary {
    margin-top: 20px;
    background-color: rgba(255, 255, 255, 0.6);

    &:hover {
      background-color: rgba(255, 255, 255, 0.9);
    }
  }

  &:hover .mm--replace-video,
  &:hover .mm--cover-image {
    visibility: visible;
  }

  .mm--replace-video,
  .mm--cover-image {
    visibility: hidden;
    transition: 0.3s;
    z-index: 11;

    &:hover {
      .Button {
        opacity: 1;
      }
    }
  }
  @media screen and (max-width: 768px) {
    .Button {
      visibility: visible;
      font-size: 0.8em !important;
    }
    .Button.primary {
      border: solid 1px rgba(255, 255, 255, 0.6);
    }
    .mm--cover-image .Button.secondary {
      background-color: rgba(255, 255, 255, 0.6);
      visibility: visible;
      font-size: 0.8em !important;
    }
  }

  @media screen and (max-width: 380px) {
    .Button {
      font-size: 0.8em !important;
    }
  }
`

export const VideoBlockWrapper = styled.div`
  @media print {
    & {
      display: flex;
      flex-direction: column;
    }
  }
  ${(props) =>
    props.layout === "center" ? "width: 80%; margin: 0 auto;" : "width: 100%"};
`
